import * as ng from 'angular';
import { ApiErrorModel, DocumentHelperService, GetEntryPointService } from '@/services';
import { OverviewDataObject } from '../../../../../organisms/overview/overview';

import './invoice-row.scss';

export class MoleculeOverviewRowPanelBillingInvoiceController implements ng.IController {
    public static $inject: string[] = ['apiErrorModel', 'documentHelper', 'getEntryPoint'];

    public overviewData: OverviewDataObject;
    public overviewLoad: () => any;
    public internalPaginationLimit: number;

    constructor(
        private apiErrorModel: ApiErrorModel,
        private documentHelper: DocumentHelperService,
        private getEntryPoint: GetEntryPointService,
    ) {}

    public $onDestroy = () => {
        this.apiErrorModel.destroyErrorList();
    };

    public downloadCsv = (invoice) => {
        this.documentHelper.csvDownloadInvoice(invoice);
    };

    public downloadPdf = (invoice) => {
        this.documentHelper.pdfDownloadInvoice(invoice);
    };

    public get errorList() {
        return this.apiErrorModel.errorObjectList;
    }

    public get isNetCologneCustomer() {
        return this.getEntryPoint.isNetCologne;
    }
}

export class MoleculeOverviewRowPanelBillingInvoiceComponent implements ng.IComponentOptions {
    public require = {
        OrganismOverview: '^organismOverview'
    };
    public bindings = {
        internalPaginationLimit: '<',
        overviewData: '<',
        overviewLoad: '<'
    };
    public controller =  MoleculeOverviewRowPanelBillingInvoiceController;
    public controllerAs = 'OverviewInvoiceCtrl';
    public template = require('./invoice-row.html');
}
